import { DecodedMessage as DecodedMessageV0 } from "@waku/core/lib/message/version_0";
import { equals } from "uint8arrays/equals";
export class DecodedMessage extends DecodedMessageV0 {
    signature;
    signaturePublicKey;
    _decodedPayload;
    constructor(pubsubTopic, proto, decodedPayload, signature, signaturePublicKey) {
        super(pubsubTopic, proto);
        this.signature = signature;
        this.signaturePublicKey = signaturePublicKey;
        this._decodedPayload = decodedPayload;
    }
    get payload() {
        return this._decodedPayload;
    }
    /**
     * Verify the message's signature against the public key.
     *
     * @returns true if the signature matches the public key, false if not or if no signature is present.
     */
    verifySignature(publicKey) {
        if (this.signaturePublicKey) {
            return equals(this.signaturePublicKey, publicKey);
        }
        return false;
    }
}
//# sourceMappingURL=decoded_message.js.map